import 'reflect-metadata';

import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { DEFAULT_LOS_ID } from '@app/shared/constants/globalConstants';

if (environment.production) {
  enableProdMode();
}

(async () => {
  setTimeout(() => {
    const losId = JSON.parse(sessionStorage.getItem('hubData'))['LosId'];

    if (
      losId !== DEFAULT_LOS_ID ||
      window.location.href.indexOf('review') !== -1
    ) {
      sessionStorage.setItem('appName', 'EXPRESS');
    } else {
      sessionStorage.setItem('appName', 'DIRECT');
    }

    platformBrowserDynamic()
      .bootstrapModule(AppModule)
      .catch(err => console.error(err));
  }, 1500);
})();
